const tile = (active) => `shrink-0 w-16 h-20 rounded-lg overflow-hidden border-2 transition-colors duration-200 ${active ? "border-[#533C25]" : "border-transparent hover:border-[#CDC0B0]"}`;

export const ProductThumbs = ({ images, view, onSelect }) => (
  <div className="flex gap-2 mt-4 overflow-x-auto pb-1" data-testid="product-gallery-thumbs">
    {images.map((src, i) => (
      <button key={src} type="button" onClick={() => onSelect(i)} className={tile(view === i)} data-testid={`product-gallery-thumb-${i}`}>
        <img src={src} alt="" className="w-full h-full object-cover" />
      </button>
    ))}
  </div>
);
